import React from 'react';
import PropTypes from 'prop-types';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y, Virtual } from 'swiper';
import FadeIn from 'react-fade-in';

//#region //// DUCKS ////
import * as hooks from '../ContentListCarousel/hooks';
import '../ContentListCarousel/styles.scss';
import classNames from '../../utils/classnameUtils';
import { Imgcomponent } from '../..';
import { getUrlUnityImageApi } from '../../utils/imageUtils';
import { sizeGroupFunction } from '../ContentListCarousel';
import { IMAGE_CROP_MODES } from "../shared/constants"
//#endregion

// install Swiper components
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Virtual]);

function SectionNav({
  contentCollection = [],
  imageMode = 'THUMB',
  selectedContentHandler = (c) => alert(`Selected Content : ${c.sectionToGoId}`),
  isLoading = false,
  countItem = 6,
}) {

  const [slideActiveIndex, setSlideActiveIndex] = React.useState(0);
  if (contentCollection.length === 0 && isLoading) contentCollection.push(...new Array(countItem))

  //#region /////// HOOKS ///////
  const { slidePerViewCount } = hooks.useSlidePerViewCount(imageMode)
  //#endregion


  return (
    <section className={("tbxContentListCarousel")}>
      <FadeIn>
        <Swiper
          className="tbxContentListCarousel__swiper"
          navigation={true}
          grabCursor={false}
          draggable={false}
          mousewheel={{
            forceToAxis: true
          }}
          loop={false}
          {...sizeGroupFunction(imageMode)}
          preventClicksPropagation={true}
          preventClicks={true}
          scrollbar={{ draggable: false, hide: true }}
          slideToClickedSlide={false}
          pagination={{ clickable: true }}
          onSlideChange={(swiper) => {
            setSlideActiveIndex(swiper.activeIndex)

            if (
              (contentCollection.length - (slidePerViewCount.slidesPerView * 2) > swiper.activeIndex)
            )
              return;
          }}
          virtual
          slidesPerView={slidePerViewCount.slidesPerView}
        >
          {contentCollection.map((content, idx) => {
            const key = `tbxContentListCarousel-item-${idx}`
            const imageSrc = content?.images[0]?.url;
            const imageSize = content?.images[0]?.size;
            return (
              <SwiperSlide

                onClick={() => {
                  if (!isLoading) selectedContentHandler(content)
                }}
                virtualIndex={key}
                key={key}
                className={classNames({
                  'tbxContentListCarousel__swiper-content': true,
                  [`__imageMode-${imageMode.toLowerCase()}`]: true,
                  'tbxContentListCarousel-loading': isLoading,
                  'tbxContentListCarousel-firstSlice': idx == slideActiveIndex,
                  'tbxContentListCarousel-lastSlice': (idx == (slideActiveIndex + (slidePerViewCount - 1)))
                })}
              >
                <div className='tbxContentListCarousel__swiper-content-wrapper'>
                  {/* IMG */}
                  {
                    imageSrc && <Imgcomponent
                      {...{
                        alt: `img-content-${content.sectionToGoId}`,
                        src: getUrlUnityImageApi(imageSrc),
                        crop: IMAGE_CROP_MODES.original,
                        size: 'THUMB',
                        loading: false,
                        width: imageSize['width'] - 50,
                        height: imageSize['height'] - 50,
                        setimagebool: (e) => console.log(e),
                      }}
                    />
                  }
                  <div className='tbxSectionNav_title'>{content?.title}</div>
                </div>
              </SwiperSlide>
            );
          })
          }
        </Swiper>
      </FadeIn>
    </section >
  );
};

SectionNav.propTypes = {
  contentCollection: PropTypes.array,
  imageMode: PropTypes.string,
  selectedContentHandler: PropTypes.func,
  isLoading: PropTypes.bool,
  countItem: PropTypes.number,
};


export default React.memo(SectionNav);




